import { Link } from "react-router-dom";

const Home = () => {
  return (
    <>
      <h1>Skak score</h1>
      <p>Skak score er en simpel måde at holde styr på point i brædtspillet</p>
      <Link target="_blank" to="https://hogsted.dk/">https://hogsted.dk/</Link>
    </>
  )
};

export default Home;